import {DatePipe, NgClass, NgFor, NgIf, NgStyle} from "@angular/common";
import {Component} from "@angular/core";
import {ReactiveFormsModule} from "@angular/forms";
import {OpportunityService} from "../../../../core/services/opportunity.service";
import {PageConfigurationService} from "../../../../core/services/page-configuration.service";
import {AddNewInputFieldComponent} from "../../../add-new-input-field/add-new-input-field.component";
import {PriceAndCargoComponent} from "../../../price-and-cargo/price-and-cargo.component";
import {BookingComponent} from "../booking/booking.component";
import {OrderSummaryComponent} from "../../../order-summary/order-summary.component";
import {
    PaymentCardInputWrapperComponent
} from "../../../payment/payment-card-input-wrapper/payment-card-input-wrapper.component";
import {FormValueSyncDirective} from "../../../../core/directives/form-value-sync.directive";
import {SignatureInputComponent} from "../../../shared/signature-input/signature-input.component";
import {DateInputComponent} from "../../../shared/date-input/date-input.component";
import {TermsDisplayComponent} from "../../../shared/terms-display/terms-display.component";

@Component({
    selector: "app-book-quote",
    standalone: true,
    imports: [
        ReactiveFormsModule,
        NgIf,
        NgClass,
        NgStyle,
        NgFor,
        DatePipe,
        PriceAndCargoComponent,
        AddNewInputFieldComponent,
        OrderSummaryComponent,
        PaymentCardInputWrapperComponent,
        FormValueSyncDirective,
        SignatureInputComponent,
        DateInputComponent,
        TermsDisplayComponent
    ],
    templateUrl: "../booking/booking.component.html",
    styleUrl: "../booking/booking.component.scss",
})
export class BookQuoteComponent extends BookingComponent {
    constructor(
        opportunityService: OpportunityService,
        configurationService: PageConfigurationService
    ) {
        super();
        this.opportunityService = opportunityService;
        this.configurationService = configurationService;
        this.opportunityService.getDetails("quotes").subscribe();
    }
}
